import config from './config.js';
import { generateRandomPastelColor } from './colorUtils.js';

export class Food {
    constructor() {
        this.x = Math.random() * config.gameWidth;
        this.y = Math.random() * config.gameHeight;
        this.mass = config.foodMass;
        this.radius = 4;
        this.color = generateRandomPastelColor(); // Assign a random pastel color once
    }
}
